module.exports = {
  headerItems: {
    "earth ethos": [
      ["our story", "our story"],
      ["sierra nevada", "sierra nevada"],
      ["avicanna standards of quality", "AVI standard of quality"],
    ],
    "our products": [
      ["beauty line", "beauty line"],
      ["moisture and protection", "moisture and protection"],
      ["specialized care", "specialized care"],
    ],
    "CBD Sense": [["FAQ", "FAQ"]],

    "store locator": [],
  },

  newsletter: "Newsletter",
  connectToUs: "Connect with us",
  subscribeToOurNewsletter: "Subscribe to our newsletter",
  ourStory: "Our Story",
  ourProducts: "Our Products",
  specialOffers: "Special Offers",
  faqProducts: "FAQ",
  contactUs: "Contact us",
  termsOfUse: "Terms of Use",
  privacyPolicy: "Privacy Policy",
  accessibility: "Accessibility",
  submit: "Submit",
  yourEmail: "your email",
  newsletterText:
    "We’re glad you opened your mind to something new! Subscribe using your email address to stay updated on the latest and greatest from Pura Earth.",
  welcomeTo: "Welcome to",
  emailAddress: "EMAIL ADDRESS",
  seeMore: "See more",
  yourCart: "Your Cart",
  ViewOrderSummary: "View order summary",
  noItemsInCart: "You have no items in your cart.",
  startBrowsing: "Start browsing!",
  ViewAllProducts: "View All Products",
  subtotal: "Subtotal",
  shipping: "Shipping",
  taxes: "Taxes",
  checkout: "Checkout",
  remove: "Remove",
  thanksForSubscribing:
    "Hello friend! You are now subscribed. Thanks for joining the Pura Earth family! It’s time to start living the Pura Life. Stay tuned for news, updates and much more.",
  somethingWentWrong: "Something went wrong",
  newsletterSubscribed:
    "Welcome to Pura Earth! We're happy you're here. You can look forward to receiving news and offers about our products.",
  newsletterFailure:
    "Sorry, but unfortunately we were unable to complete your subscription. Please try again in a few minutes.",
  continueShopping: "Continue Shopping",
  proceed: "proceed",
  followInstagram: "Follow us on Instagram",
  redictingToPayU: "Redirecting to PayU, please wait...",
  youAreBeingRedirected1: "You are being redirected to",
  youAreBeingRedirected2: "to complete your purchase securely.",
  yourTransaction: "Your transaction has been approved",
  paymentReference: "Payment reference: ",
  followUpRef:
    "Please use this payment reference number in order to follow up on your transaction with our customer service team.",
  otherProducts: "Other Products",
  benefits: "Benefits",
  securedPayments: "Secured Payments by",
  discover: "Discover",
  yourTransRejected: "Your transaction has been rejected",
  rejectedPayment:
    "Unfortunately, your payment could not be accepted at this time. Please check your information and try again.",
  startExploring: "Start Exploring",
  splashCopyText:
    "We invite you to experience the unique beauty of nature and science brought together in Pura Earth skin care products.",
  yourTransactionPending: "Your transaction has been pending",
  PendingPayment:
    "Thank you for your order! You'll receive an email it has been processed.",
  failedCheckout:
    "Sorry, but unfortunately we were unable to checkout. Please try again in a few minutes.",
  outOfStock: "Currently out of stock",
  checkoutNotPermitted: "Can't proceed to payment",
  checkoutNotPermittedReason:
    "One or more of your items is out of stock. Please remove then and then proceed with your checkout.",
  checkoutDismissModal: "Close",

  contactInformation: "Contact information",
  emailAddress: "EMAIL ADDRESS",
  enterValidEmail: "Please enter a valid email address",
  receiveNewsUpdates:
    "I would like to receive news and updates about Pura Earth Products",
  shippingAddress: "Shipping Address",
  firstName: "FIRST NAME",
  enterFirstName: "Please enter a first name",
  lastName: "LAST NAME",
  enterLastName: "Please enter a last name",
  address: "ADDRESS",
  enterAddress: "Please enter an address",
  ID: "IDENTIFICATION (ONLY FOR COLOMBIA)",
  enterID: "Please enter an identification document",
  enterApartment: "APARTMENT, SUITE, UNIT (OPTIONAL)",
  city: "CITY",
  enterCity: "Please enter a city",
  countryRegion: "COUNTRY / REGION",
  enterCountryRegion: "Please enter a country/region",
  province: "PROVINCE",
  enterProvince: "Please enter a province",
  zipPostalCode: "ZIP / POSTAL CODE",
  enterZipPostalCode: "Please enter a zip/postal code",
  phoneNumber: "PHONE NUMBER (OPTIONAL)",
  billingAddress: "Billing Address",
  shippingAsBilling: "Use shipping address as billing address",
  sameAddrShipping: "Same address provided for Shipping",
  useDiffBilling: "Use a different billing address",
  continueShopping: "CONTINUE SHOPPING",
  continueToPayment: "CONTINUE TO PAYMENT",
  proceed: "PROCEED",
  securePaymentsBy: "Secured Payments by",
  avicannaTOS: "© 2020 Avicanna Pura Earth",
  refTitle: "References",
  termsOfUse: "Terms of Use",
  privacyPolicy: "Privacy Policy",
  addToCart: "Add to cart",
  addedToCart: "Added to cart",
  quantity: "Quantity",
  hasBeenAddedToCart: "has been added to your cart",
  invalidEmail: "Invalid Email",
  pleaseEntervalidEmail: "Please enter a valid email.",
  storeLocator: "Store Locator",
  selectCityStore: "Select a city to display stores",
  selectCity: "Select a city",
  lastUpdated: "Last updated: ",
  termsOfUse: "Terms of Use",
  notFoundTitle: "404 not found",
  notFoundMessage:
    "We're sorry, the page you were looking for cannot be found.",
  backHomepage: "Go back to homepage",
  FAQ: "FREQUENTLY ASKED QUESTIONS",
  CC: "C.C. (Certificate of Citizenship)",
  CE: "C.E. (Immigration Certificate)",
  NIT: "NIT (Company Tax ID number)",
  passport: " Passport",
  other: "Other",
  outOfServiceTitle: "Dear Customer: ",
  outOfServiceContent:
    "We are making changes so you can have a better shopping experience, that's why every order you make after December 18th will be at your home on January 15th.",
  merryChristmas: "We wish you a Merry Christmas and a Happy Year 2020.",
  selectACity: "Select a city",
  covidBanner: "Dear Customer, You may experience delays during the shipment of your order due to the extraordinary circumstances as a result of COVID-19.  We appreciate your patience.",
  popupHeader:"GET 10% OFF ",
  discountHeader:"OF YOUR FIRST ORDER",
  emailPlaceholder:"E-MAIL ADDRESS",
  checkbox:"Yes, I would like to receive communications, updates, and offers from Pura Earth. By subscribing I acknowledge that I have read and agree to the Terms of Service and Privacy Policy, including Cookie Use.",
  notChecked:"Please check this box if you want to proceed",
  apply:"apply",
  duplicated:"You have already subscribed!",
  emailUsed:"Please enter another email",
  promoCode:"Promo Code",
  discount:"Discount",
  wrongPromo:"Invalid Promo Code",
  noPromo:"Insert Promo Code",
  notEligible:"You are not eligible to use this Promo code",
  usedPromo:"You used this promo code before",
  usedPromoEmailWarning:"Please enter email address to use promo code",
  receive:"GET  A SPECIAL 10% OFF WELCOME OFFER FOR FIRST TIME SUBSCRIBERS SENT TO YOUR INBOX\n",
  unsubscribed:"You have been unsubscribed from this publication.",
  resubscribe:"To re-subscribe, visit our website at",
  puraearth:"www.puraearth.com",
  locationAlertMsg:"Only Available in Colombia",
}
